module.exports = __webpack_public_path__ + "static/media/cross-with-circle.5bf1d514.svg";